import PropTypes from 'prop-types';
import React from 'react';
import { setNativeValue } from '../../../utils/react-utils';
import styles from './styles.scss';

class Datalist extends React.Component {
    constructor(props) {
        super(props);

        this.showOptions = this.showOptions.bind(this);
        this.hideOptions = this.hideOptions.bind(this);
        this.toggleOptions = this.toggleOptions.bind(this);
        this.updateValue = this.updateValue.bind(this);
        this.handleOptionClick = this.handleOptionClick.bind(this);

        // Generate the options list here instead of in render so that each key is stable.
        this.options = props.options.map((v, i) => ({ key: props.name + i, value: v }));

        this.state = {
            showOptions: false,
            value: props.defaultValue,
        };
    }

    componentDidMount() {
        const { inputRef } = this.props;
        const { value } = this.state;

        // blur event on the input messes up the click even on the options.
        // using mousedown event helps but is not ideal.
        this.input.addEventListener('blur', this.hideOptions, false);

        this.inputContainer.addEventListener('click', this.toggleOptions, false);

        [...this.datalist.children].forEach((o) => {
            o.addEventListener('mousedown', this.handleOptionClick, false);
        });

        // bind the local ref to the ref passed through props
        inputRef(this.input);

        // if there is no default value, set the first option as default
        const defaultOption = [...this.datalist.children]
            .find((o) => o.dataset.value === value)
            ?? this.datalist.children[0];

        // fire the mousedown event to validate the default.
        defaultOption.dispatchEvent(new Event('mousedown'));
    }

    handleOptionClick(e) {
        const { value } = e.target.dataset;

        setNativeValue(this.input, value);
        const event = new Event('change', { bubbles: true });

        this.input.dispatchEvent(event);

        this.setState(() => ({
            value,
            showOptions: false,
        }));
    }

    updateValue(e) {
        const {
            validation, inputType, max, min,
        } = this.props;

        const { value } = e.target;

        let errorMessage = '';
        if (inputType === 'number') {
            try {
                const intValue = parseFloat(value);
                if (intValue > max || intValue < min) {
                    errorMessage = 'Please enter a number in range';
                }
            } catch {
                errorMessage = 'Please enter a number in range';
            }
        }

        this.setState(() => ({
            value,
            showOptions: false,
        }), () => validation(e, errorMessage));
    }

    toggleOptions() {
        const { showOptions } = this.state;
        if (showOptions === true) {
            this.hideOptions();
        } else {
            this.showOptions();
        }
    }

    showOptions() {
        const { showOptions } = this.state;
        if (showOptions === false) {
            this.setState(() => ({
                showOptions: true,
            }));
        }
    }

    hideOptions() {
        const { showOptions } = this.state;
        if (showOptions === true) {
            this.setState(() => ({
                showOptions: false,
            }));
        }
    }

    render() {
        const {
            name,
            placeholder,
            invalidclass,
            inputType,
            max,
            min,
        } = this.props;
        const { showOptions, value } = this.state;

        const elements = this.options.map((kv) => <div className={styles['custom-option']} data-value={kv.value} key={kv.key}>{kv.value}</div>);

        const arrow = showOptions ? styles.up : '';
        const show = showOptions ? styles.show : '';

        let input = (
            <input
                className={`input ${invalidclass}`}
                ref={(ref) => { this.input = ref; }}
                name={name}
                placeholder={placeholder}
                value={value}
                data-testid={`${name}-input`}
                onChange={this.updateValue}
            />
        );

        if (inputType === 'number') {
            input = <input type="number" max={max} min={min} ref={(ref) => { this.input = ref; }} {...input.props} />;
        }

        return (
            <div className={styles.datalist}>
                <div className={`${styles.datalistInput} ${arrow}`} ref={(ref) => { this.inputContainer = ref; }} data-testid={`${name}-datalist`}>
                    {input}
                </div>
                <div className={`${styles['custom-datalist']} ${show}`}>
                    <div ref={(ref) => { this.datalist = ref; }}>
                        {elements}
                    </div>
                </div>
            </div>
        );
    }
}

Datalist.propTypes = {
    name: PropTypes.string.isRequired,
    inputRef: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
    placeholder: PropTypes.string,
    validation: PropTypes.func,
    invalidclass: PropTypes.string,
    defaultValue: PropTypes.string,

    inputType: PropTypes.string,
    max: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    min: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
};

Datalist.defaultProps = {
    placeholder: '',
    validation: () => { },
    invalidclass: '',
    defaultValue: '',
    inputType: 'text',
    min: 0,
    max: 9999,
};

export default Datalist;
